import fetch from '@/utils/fetch.js'

// 获取配置信息
export function trustSubmit(data = {}) {
  return fetch({
    url: 'ownerEntrust/submit',
    method: 'POST',
    data,
    json:'json',
    headers:{'content-type': 'application/json'}
  })
}